import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { GetAgent } from "../../store/actions/kalapost";
import { toggleSidebar } from "../../store/actions/layout";
import { errorMessage } from "../../utils/message";

const Agent = () => {
  const dispatch = useDispatch();
  const { isSidebarOpened } = useSelector((state) => state.layout);

  const [agents, setAgents] = useState([]);
  const [search, setSearch] = useState({ cityName: "", branchName: "" });

  const searchUnit = agents.filter((agent) => {
    const x = search.cityName && agent.cityName?.includes(search.cityName?.toLowerCase());
    const y = search.branchName && agent.branchName?.includes(search.branchName?.toLowerCase());
    return x || y;
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleGetAgent = async () => {
      const res = await GetAgent();
      res.status && setAgents(res.data);
    };
    handleGetAgent();
  }, []);

  const handleSearch = (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });
  };

  return (
    <>
      <h1 style={{ color: 'var(--primary)', fontSize: '1.9rem', textAlign: 'center', padding: '20px 16px 12px' }}>نمایندگی‌های کالاپست</h1>
      <main
        className="agent"
        onClick={() => isSidebarOpened && dispatch(toggleSidebar())}
      >
        <div className="agent__content">
          <div className="agent__inputs">
            <input
              className="agent__input"
              id="cityAgent"
              type="text"
              name="cityName"
              placeholder="شهر مورد نظر"
              value={search.cityName}
              onChange={handleSearch}
            />
            <input
              className="agent__input"
              id="nameAgent"
              type="text"
              name="branchName"
              placeholder="نام نمایندگی"
              value={search.branchName}
              onChange={handleSearch}
            />
          </div>

          {(search.cityName || search.branchName ? searchUnit : agents).length !== 0 ?
            <div className="agent-cards">
              {(search.cityName || search.branchName ? searchUnit : agents).map((agent, index) => (
                <div key={index} className="agent-cards__card">
                  <div className="agent_cart-header">
                    <img
                      src="/img/agent.png"
                      alt="agent"
                      className="agent-cards__image"
                      style={{ paddingBottom: '5px', }}
                    />
                    <span>{agent.branchName}</span>
                  </div>

                  <div className="agent-cards__list">
                    <div className="agent-cards__item">
                      <h5 className="agent-cards__title">شهر:</h5>
                      <p className="agent-cards__text">{agent.cityName}</p>
                    </div>
                    <div className="agent-cards__item">
                      <h5 className="agent-cards__title">شماره تلفن:</h5>
                      <p className="agent-cards__text">{agent.phoneNumber}</p>
                    </div>
                    <div className="agent-cards__item">
                      <h5 className="agent-cards__title">مدیر نمایندگی:</h5>
                      <p className="agent-cards__text">{agent.managerName}</p>
                    </div>
                    <div className="agent-cards__item">
                      <h5 className="agent-cards__title">شماره همراه مدیر:</h5>
                      <p className="agent-cards__text">{agent.managerPhoneNumber}</p>
                    </div>
                  </div>

                  <div className="agent-cards__item agent-cards__item--address">
                    <h5 className="agent-cards__title">آدرس:</h5>
                    <p className="agent-cards__text">{agent.address}</p>
                  </div>
                </div>
              ))}

            </div>
            :
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '30px 0 25px' }}>
              <img src="/img/not-found_5408094.png" className="not-found_img" />
            </div>
          }
        </div>
        <Link
          to="/order"
          className="main__Send-package"
        >
          <img className="main__Send-package-img" src="/img/postfix.png" alt="" />
          <h4>ارسال بسته</h4>
        </Link>
      </main>
    </>

  );
};

export default Agent;
